import { setCreateJobStatus } from "actions/jobs";
import { push } from "connected-react-router";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.jobs.ICreateJob) {
    yield put(setCreateJobStatus("loading"));
    try {
        const response = yield post("/create-job-2", {
            file_id: action.fileId,
            render_animation: action.isAnimation,
            start_frame: action.startFrame,
            end_frame: action.endFrame,
            name: action.name ? action.name : null,
            render_engine: action.renderEngine,
            job_type: action.jobType,
            team_id: action.teamId,
        });
        if (response.data != null) {
            yield put(setCreateJobStatus("success"));
            yield put(push("/home/dashboard/jobs/" + response.data.id));
        } else {
            yield put(setCreateJobStatus("error"));
        }
    } catch (e) {
        yield handleNetworkError(e);
        yield put(setCreateJobStatus("error"));
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.jobs.ICreateJob", execute);
}
